import { render, staticRenderFns } from "./UIUploadFile.vue?vue&type=template&id=ae4e932e&scoped=true"
import script from "./UIUploadFile.vue?vue&type=script&lang=js"
export * from "./UIUploadFile.vue?vue&type=script&lang=js"
import style0 from "./UIUploadFile.vue?vue&type=style&index=0&id=ae4e932e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4e932e",
  null
  
)

export default component.exports